import { ajax } from "discourse/lib/ajax";
import DiscourseRoute from "discourse/routes/discourse";

export default class ProxyviewsGuidesRoute extends DiscourseRoute {
  // Re-run the model hook when category/page query params change so that
  // clicking a filter button (or a pagination link) re-fetches the data.
  // Without this, Ember updates the URL but leaves the stale list on screen.
  queryParams = {
    category: { refreshModel: true, replace: true },
    page: { refreshModel: true, replace: true },
  };

  async model(params) {
    const queryParams = new URLSearchParams();
    if (params.category) queryParams.set("category", params.category);
    if (params.page) queryParams.set("page", params.page);

    const qs = queryParams.toString();
    const url = `/guides.json${qs ? `?${qs}` : ""}`;
    const data = await ajax(url);

    const guides = (data.guides || []).map((g) => ({
      ...g,
      url: `/guides/${g.slug}`,
      categoryLabel: (g.category || "guide").replace(/-/g, " "),
    }));

    return {
      guides,
      categories: data.categories || [],
      meta: {
        page: data.page || 1,
        totalPages: data.total_pages || 1,
        total: data.total || 0,
        category: data.category || null,
      },
    };
  }

  titleToken() {
    return "Proxy Guides";
  }
}
